import '@stylesheets/application'
import '@fortawesome/fontawesome-free/js/all'
import 'channels'

import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'
import '../setups/react'
import toastr from 'toastr/toastr'
import 'toastr/build/toastr.css'
import index from 'cd-atwho'

toastr.options = {
  positionClass: 'toast-bottom-right',
  preventDuplicates: true,
  preventOpenDuplicates: true
}

const application = Application.start()
const context = require.context('controllers', true, /\.js$/)
application.load(definitionsFromContext(context))
window.toastr = toastr

let containerScrollTops = {}

document.addEventListener('click', () => {
  document
    .querySelectorAll('[data-turbolinks-preserve-scroll-container]')
    .forEach((ele) => {
      containerScrollTops[ele.dataset.turbolinksPreserveScrollContainer] =
        ele.scrollTop
    })
})

// cleanup tom-select
document.addEventListener('turbolinks:before-cache', () => {
  document.querySelectorAll('.is-tom-select').forEach((el) => {
    if (el.tomselect) el.tomselect.destroy()
  })
})

document.addEventListener('turbolinks:load', () => {
  document
    .querySelectorAll('[data-turbolinks-preserve-scroll-container]')
    .forEach((ele) => {
      const containerScrollTop =
        containerScrollTops[ele.dataset.turbolinksPreserveScrollContainer]
      if (containerScrollTop) ele.scrollTo(0, containerScrollTop)
    })

  containerScrollTops = {}
})
